import { OutletIndicator } from '@components/common';
import { ShieldCheck } from 'lucide-react';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SecuritySubnav } from './SecuritySubnav';

export const SecurityPage: React.FC = () => (
  <div className="space-y-6">
    <div className="rounded-2xl border border-gray-200 bg-white p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="flex items-center gap-2 text-pos-primary">
            <ShieldCheck size={18} />
            <span className="text-xs font-semibold uppercase tracking-[0.24em]">
              Access security
            </span>
          </div>
          <h2 className="mt-3 text-xl font-semibold text-black">
            Company access controls
          </h2>
          <p className="mt-2 max-w-3xl text-sm leading-6 text-gray-600">
            Build reusable policies from the global control catalog, then attach
            those policies to outlet roles. Super, admin, and super admin users
            remain unrestricted.
          </p>
        </div>
      </div>
      <div className="mt-4">
        <OutletIndicator description="No outlet selected. Policies remain company-wide, and role assignments below will cover all outlets." />
      </div>
    </div>

    <SecuritySubnav />
    <Outlet />
  </div>
);
